'use client';

import React from 'react';
import { House, CaretRight } from 'phosphor-react';
import { usePathname } from 'next/navigation';
import useRoute from '@/ueshook/useRoute';

interface BreadcrumbsProps {
  className?: string;
  // 其他可能的属性
}

export default function Breadcrumbs({ className }: BreadcrumbsProps) {
  const { push } = useRoute();
  const pathname = usePathname();
  const pathSegments = pathname?.split('/').filter((segment) => segment) ?? [];

  const pages = pathSegments.map((segment, index) => {
    const href = '/' + pathSegments.slice(0, index + 1).join('/');
    return {
      name:
        segment === 'api'
          ? segment.toUpperCase()
          : segment.charAt(0).toUpperCase() + segment.slice(1),
      href: href,
      current: index === pathSegments.length - 1,
    };
  });

  return (
    <nav
      aria-label='Breadcrumb'
      className={`z-40 border-b border-gray-200 pt-0 md:flex ${className} h-0 w-0 overflow-hidden md:h-auto md:w-auto`}
      style={{ visibility: 'hidden', height: 0 }}
    >
      <ol
        role='list'
        className='mx-auto flex w-full max-w-screen-xl space-x-4 px-8 sm:px-8 lg:px-6'
      >
        <li className='flex'>
          <div className='flex items-center'>
            {pathname !== '/' && (
              <span
                className='cursor-pointer text-gray-400 hover:text-gray-500'
                onClick={() => push('/')}
              >
                <House size={20} weight='fill' />
                <span className='sr-only'>Home</span>
              </span>
            )}
          </div>
        </li>
        {pages.map((page) => (
          <li key={page.name} className='flex'>
            <div className='flex items-center'>
              <CaretRight size={20} className='text-gray-400' />
              <span
                onClick={() => push(page.href)}
                aria-current={page.current ? 'page' : undefined}
                className='ml-4 cursor-pointer text-sm font-medium text-gray-500 hover:text-gray-700'
              >
                {page.name}
              </span>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
